<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        label="分类名称	"
        prop="className"
      ></el-table-column>

      <el-table-column align="center" label="内容" prop="content" width="200">
        <template slot-scope="scope">
          <div class="two-line-ellipsis">{{ scope.row.content }}</div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="图片" prop="images">
        <template slot-scope="scope" v-if="scope.row.images">
          <el-image
            v-for="(item, index) in scope.row.images.split(',')"
            :key="index"
            :src="item"
            fit="fill"
            :preview-src-list="scope.row.images.split(',')"
            style="width: 50px; height: 50px; margin-right: 5px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="置顶" prop="isTop">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isTop"
            :active-value="1"
            :inactive-value="0"
            @change="handleChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="创建用户"
        prop="nickName"
      ></el-table-column>
      <el-table-column
        width="180"
        align="center"
        label="创建时间"
        prop="createTime"
      ></el-table-column>

      <el-table-column align="center" label="审核状态" prop="reviewStatus">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.reviewStatus == 1" type="success"
            >审核通过</el-tag
          >
          <el-tag v-else-if="scope.row.reviewStatus == 2" type="danger"
            >审核驳回</el-tag
          >
          <el-tag v-else type="info">待审核</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="审核时间"
        prop="reviewTime"
        width="180"
      ></el-table-column>

      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            plain
            v-if="scope.row.reviewStatus == 0"
            type="primary"
            @click="handleStatus(scope.row, 1)"
            >审核</el-button
          >
          <el-button
            plain
            v-if="scope.row.reviewStatus == 1"
            type="success"
            @click="handleStatus(scope.row, 2)"
            >评论</el-button
          >
          <el-button
            plain
            v-if="scope.row.reviewStatus == 1"
            type="warning"
            @click="handleStatus(scope.row, 3)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :total="searchForm.total"
    ></el-pagination>
    <el-dialog
      :before-close="handleClose"
      title="审核"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="审核状态" prop="reviewStatus">
          <el-radio-group v-model="editForm.reviewStatus">
            <el-radio label="1">审核通过</el-radio>
            <el-radio label="2">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="评论"
      :visible.sync="dialogVisiblechat"
      append-to-body
      width="50%"
    >
      <el-form
        ref="chatForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="是否置顶" prop="isTop">
          <el-radio-group v-model="editForm.isTop">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="评论内容" prop="content">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="editForm.content"
          >
          </el-input>
        </el-form-item>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('chatForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="详情"
      :visible.sync="dialogVisibledetail"
      append-to-body
      width="50%"
      top="5vh"
    >
      <div style="display: flex; flex-direction: column">
        <div class="dialog-content">
          <div class="dialog-flex">
            <div class="dialog-flex-img">
              <img :src="editForm.avatarUrl" alt="" style="" />
            </div>
            <div>
              <div class="dialog-flex-name">{{ editForm.nickName }}</div>
              <div class="dialog-flex-times">{{ editForm.createTime }}</div>
            </div>
          </div>
          <div class="dialog-text">
            <div>{{ editForm.content }}</div>
            <div v-if="editForm.images">
              <el-image
                style="width: 60px; height: 60rpx"
                v-for="(item, index) in editForm.images.split(',')"
                :key="index"
                :src="item"
                fit="fill"
                :preview-src-list="editForm.images.split(',')"
              ></el-image>
            </div>
          </div>
        </div>
        <div style="height: 20px"></div>
        <el-divider content-position="left">评论列表</el-divider>
        <div class="dialog-count">评论数({{ chatCount }})</div>
        <div
          class="dialog-chat"
          style="overflow: auto"
          ref="chatContainer"
          @scroll="handleChatScroll"
        >
          <div
            v-for="(item, index) in chatList"
            :key="index"
            style="margin-left: 20px"
          >
            <div class="dialog-Subset">
              <div class="dialog-Subset-img">
                <img :src="item.avatarUrl" alt="" style="" />
              </div>
              <div>
                <div class="dialog-Subset-name">{{ item.nickName }}</div>
                <div class="dialog-Subset-times">{{ item.createTime }}</div>
              </div>
            </div>
            <div class="dialog-Subset-text">
              <div>{{ item.content }}</div>
              <div v-if="item.images">
                <el-image
                  style="width: 60px; height: 60px"
                  v-for="(item, index) in item.images.split(',')"
                  :key="index"
                  :src="item"
                  fit="fill"
                  :preview-src-list="item.images.split(',')"
                ></el-image>
              </div>
            </div>
            <el-divider></el-divider>
          </div>
        </div>

        <el-divider content-position="left">评论</el-divider>

        <el-form
          ref="detailForm"
          :model="editForm"
          :rules="rules"
          class="demo-editForm"
          label-width="100px"
        >
          <el-form-item prop="userContent" label="评论内容">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.userContent"
            />
          </el-form-item>
          <el-form-item
            label="是否置顶"
            prop="userisTop"
            style="margin-bottom: 0px !important"
          >
            <el-radio-group v-model="editForm.userisTop">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            style="
              margin-top: 10px;
              text-align: center;
              margin-bottom: 0px !important;
            "
          >
            <el-button type="primary" @click="submitForm('detailForm')"
              >提交评论</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "technology",
  components: {},
  data() {
    return {
      editForm: {
        reviewStatus: "",
        isTop: "",
        content: "",
        userContent: "",
        userisTop: "",
      },
      content: "",
      tableData: [],
      dialogVisible: false,
      dialogVisiblechat: false,
      dialogVisibledetail: false,
      rules: {
        reviewStatus: [
          { required: true, message: "请选择审核状态", trigger: "blur" },
        ],
        isTop: [{ required: true, message: "请选择是否置顶", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        userContent: [
          { required: true, message: "请输入评论内容", trigger: "blur" },
        ],
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      chatList: [],
      chatpageNo: 1,
      chatCount: 0,
      isLoading: false,
    };
  },
  created() {
    this.getHomePopList();
  },
  methods: {
    handleChatScroll() {
      if (this.isLoading) return; // 如果正在加载中，不重复触发
      const container = this.$refs.chatContainer;
      const isBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight <
        10;
      if (isBottom) {
        // 判断是否还有更多数据可以加载
        if (this.chatList.length < this.chatCount) {
          this.isLoading = true;
          this.chatpageNo += 1;
          this.handleChatList();
        }
      }
    },
    handleChatList() {
      this.$axios
        .post("/admin/technology/getChatList", {
          id: this.editForm.id,
          pageSize: 10,
          pageNo: this.chatpageNo,
        })
        .then((res) => {
          if (this.chatpageNo === 1) {
            this.chatList = res.data.records;
          } else {
            // 滚动加载时，将新数据追加到现有列表
            this.chatList = [...this.chatList, ...res.data.records];
          }
          this.chatCount = res.data.total;
          this.isLoading = false;
        });
    },

    handleChange(row) {
      this.$axios
        .post("/admin/technology/updTop", {
          id: row.id,
          isTop: row.isTop,
        })
        .then((res) => {
          this.$message({
            message: "恭喜你，操作成功",
            type: "success",
          });
        });
    },
    handleStatus(row, type) {
      // 先重置editForm对象为初始状态
      this.editForm = {
        reviewStatus: "",
        isTop: "",
        content: "",
        userContent: "",
        userisTop: "",
        id: row.id,
      };

      if (type == 1) {
        // 审核对话框
        this.dialogVisible = true;
      }
      if (type == 2) {
        // 评论对话框
        this.dialogVisiblechat = true;
      }
      if (type == 3) {
        // 详情对话框 - 正确的做法是先合并row对象的属性，然后设置对话框可见
        Object.assign(this.editForm, row);
        // 确保用户评论相关字段被重置为空
        this.editForm.userContent = "";
        this.editForm.userisTop = "";

        this.$nextTick(() => {
          this.handleChatList();
          this.dialogVisibledetail = true;
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisiblechat = false;
      this.dialogVisibledetail = false;
    },
    getHomePopList() {
      this.$axios
        .post("/admin/technology/getAdminList", {
          pageNo: this.searchForm.pageNo,
          pageSize: this.searchForm.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.searchForm.total = res.data.total;
        });
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getHomePopList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getHomePopList();
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var url = null;
          if (formName === "editForm") {
            var obj = {
              reviewStatus: this.editForm.reviewStatus,
              id: this.editForm.id,
            };

            url = "/admin/technology/review";
          }
          if (formName === "chatForm") {
            var obj = {
              isTop: this.editForm.isTop,
              content: this.editForm.content,
              id: this.editForm.id,
            };
            url = "/admin/technology/chat";
          }
          if (formName === "detailForm") {
            var obj = {
              isTop: this.editForm.userisTop,
              content: this.editForm.userContent,
              id: this.editForm.id,
            };
            url = "/admin/technology/chat";
          }

          this.$axios.post(url, obj).then((res) => {
            this.handleClose();
            this.getHomePopList();
            this.$message({
              message: "恭喜你，操作成功",
              type: "success",
            });
          });
        } else {
          return false;
        }
      });
    },

    delHandle(val) {
      var _this = this;
      this.$confirm("此操作将删除该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/admin/articleDetail/del", {
              id: val,
            })
            .then((res) => {
              _this.getHomePopList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.dialog-chat {
  margin-top: 20px;
  overflow: auto;
}
.dialog-content {
  flex-shrink: 0;
}
.dialog-count {
  font-size: 16px;
  line-height: 24px;
  color: #333;
}
.dialog-flex {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.dialog-flex-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  border-radius: 50px;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dialog-flex-name {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 6px;
}
.dialog-flex-times {
  font-size: 12px;
  color: #999;
}
.dialog-text {
  font-size: 16px;
  line-height: 24px;
  color: #333;
}

.dialog-Subset {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.dialog-Subset-img {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  border-radius: 50px;
  overflow: hidden;
}

.dialog-Subset-name {
  font-size: 12px;
  font-weight: bold;
}
.dialog-Subset-times {
  font-size: 10px;
  color: #999;
}
.dialog-Subset-text {
  font-size: 14px;
  line-height: 24px;
  color: #333;
}

.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.two-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示的行数为2 */
  -webkit-box-orient: vertical;
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
</style>
